import { render, staticRenderFns } from "./configsTable.vue?vue&type=template&id=319af268&scoped=true"
import script from "./configsTable.vue?vue&type=script&lang=js"
export * from "./configsTable.vue?vue&type=script&lang=js"
import style0 from "./configsTable.vue?vue&type=style&index=0&id=319af268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319af268",
  null
  
)

export default component.exports